<template>
  <template-info :bgImg="bgImg" title="คำอธิบายเพิ่ม">
    <div>
      <div class="cvdb-detail">
        <span>ภาษีขาย</span> คือ ภาษีมูลค่าเพิ่มที่คุณเรียกเก็บจากลูกค้า
        เมื่อขายสินค้า และให้บริการ เช่น ขายสินค้าราคา 100 บาท
        เราจะเก็บเงินจากลูกค้ามา 107 บาท ซึ่ง 7 บาทนี้เรียกว่า “ภาษีขาย”
      </div>

      <div class="cvdb-detail">
        <span>ภาษีซื้อ</span> คือ ภาษีมูลค่าเพิ่มที่คุณจ่ายให้แก่ผู้ขายที่จด
        ทะเบียนภาษีมูลค่าเพิ่ม เมื่อซื้อสินค้าและรับบริการ เช่น
        เราไปซื้อของมาราคา 50 บาท เราก็ต้องจ่ายเงินซื้อของ ไป 53.50 บาท ซึ่ง
        3.50 บาทนี้เรียกว่า “ภาษีซื้อ” โดยคำนวณจาก VAT 7%
      </div>

      <div class="cvdb-detail">
        <span>ภาษีนำส่ง</span> คือ ภาษีขาย - ภาษีซื้อ
      </div>

      <div class="cvdb-detail">
        <span>ภาษีสิ้นปี</span> คือ ภาษีที่เรียกเก็บจากรายได้ ค่าจ้าง เงินเดือน
        ค่าคอมมิชชั่น และรายได้รับล่วงหน้า (เงินปันผล ดอกเบี้ย ค่าเช่า
        กำไรจากการซื้อขาย)
      </div>

      <div class="cvdb-detail">
        <span>เงินคงเหลือ</span> คือ เงินสดคงเหลือในกระเป๋า
      </div>

      <div class="cvdb-detail">
        <span>สภาพคล่องทางการเงิน</span> คือ เงินที่หมุนเวียนเพื่อใช้จ่ายภายใน
        บริษัท หลังจากการหักภาษีต่างๆ แล้วถ้ามีเหลือมาก จะยิ่งดี
        เพราะหมายถึงมีสภาพคล่องทางการใช้จ่ายสูง
      </div>
      <external-link
        @clickLink="vatDetails"
        caption="ดูข้อมูลแบบละเอียด"
        class="link-desktop"
        style="margin-bottom: 20px;"
      />
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/corp_vat_definition.png";

export default {
  name: "CorpVatDefinition",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    vatDetails() {
      window.open(
        "https://www.rd.go.th/publish/fileadmin/user_upload/SMEs/infographic/5.vat_360.pdf",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.cvdb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}
.cvdb-detail > span {
  font-weight: bold;
}
</style>
